"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useScrollBlock = function () {
    var scroll = (0, react_1.useRef)(false);
    var disableScroll = function () {
        if (typeof document === 'undefined') {
            return;
        }
        var html = document.documentElement;
        var body = document.body;
        if (!body || !body.style || scroll.current) {
            return;
        }
        var scrollBarWidth = window.innerWidth - html.clientWidth;
        var bodyPaddingRight = parseInt(window.getComputedStyle(body).getPropertyValue('padding-right')) || 0;
        html.style.position = 'relative';
        body.style.position = 'relative';
        html.style.overflow = 'hidden';
        body.style.overflow = 'hidden';
        body.style.paddingRight = "".concat(bodyPaddingRight + scrollBarWidth, "px");
        scroll.current = true;
    };
    var enableScroll = function () {
        if (typeof document === 'undefined') {
            return;
        }
        var html = document.documentElement;
        var body = document.body;
        if (!body || !body.style || !scroll.current) {
            return;
        }
        html.style.position = '';
        html.style.overflow = '';
        body.style.position = '';
        body.style.overflow = '';
        body.style.paddingRight = '';
        scroll.current = false;
    };
    return { disableScroll: disableScroll, enableScroll: enableScroll };
};
exports.default = useScrollBlock;
